import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  dialogPaper: {
    width: 960,
    padding: 48,
    backgroundColor: theme.colorPalette.beige_25,
    display: 'flex',
    flexDirection: 'column',
    gap: 32
  },
  sectionHeading: {
    color: theme.colorPalette.green_90,
    marginBottom: 16
  },
  title: {
    marginBottom: -16
  },

  // Pricing
  pricingSection: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 32,
    marginBottom: 32
  },
  pricingCard: {
    backgroundColor: theme.colorPalette.green_90,
    color: theme.colorPalette.beige_10,
    borderRadius: 8,
    padding: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column'
  },
  collapsibleCardBuffer: {
    marginRight: 0,
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.10)'
  },
  // Applied on top of collapsibleCardBuffer only while the card is open.
  collapsibleCardBufferOpen: {
    paddingBottom: 14
  },
  noPriceDataRow: {
    display: 'flex',
    flexDirection: 'column'
  },

  noChangesReport: {
    backgroundColor: theme.colorPalette.white,
    color: theme.colorPalette.green_75,
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  noChangesCard: {
    display: 'inline-flex',
    color: theme.colorPalette.green_75,
    fontSize: 16,
    fontWeight: 400,
    fontStyle: 'italic'
  },
  noChangesIcon: {
    width: 24,
    height: 24,
    marginRight: 8
  },
  pricingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:first-child': {
      paddingBottom: 16
    },
    '&:last-child': {
      paddingTop: 16
    }
  },
  pricingRowBorder: {
    borderTop: `1px solid ${theme.colorPalette.beige_50_op_50}`
  },
  pricingLabel: {
    color: theme.colorPalette.white,
    fontWeight: 500
  },
  pricingValues: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  pricingOld: {
    color: theme.colorPalette.beige_75,
    fontSize: 20
  },
  pricingNew: {
    color: theme.colorPalette.white,
    fontSize: 20,
    fontWeight: 400
  },

  // Wraps the list of collapsible cards. CollapsibleCard's outer <Collapse> adds its own
  // marginBottom (5) + vertical padding (3) — giving ~11px between cards. Zero those out and
  // drive the spacing with an 8px flex gap instead. Left/right Collapse padding is preserved
  // (we only override the vertical values) so its full-width alignment trick still works.
  whatChangedCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& .MuiCollapse-root': {
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0
    }
  },

  // What changed heading
  whatChangedSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: 24
  },
  whatChangedSubtitle: {
    color: theme.colorPalette.green_15
  },

  collapsibleCardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: -8
  },
  collapsibleCardHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },

  // Rejection card
  rejectionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    background: theme.colorPalette.green_90,
    borderRadius: 6,
    padding: 24,
    margin: '0px 24px 16px'
  },
  icon: {
    width: 38,
    height: 48
  },

  // Change rows (per section) — wrapped in a bordered inner card
  changeGroup: {
    display: 'flex',
    flexDirection: 'column',
    border: `2px solid ${theme.colorPalette.beige_40}`,
    borderRadius: 8,
    margin: '8px 24px',
    padding: 4
  },
  subSection: {
    display: 'flex',
    flexDirection: 'column',
    '&:not(:first-child)': {
      borderTop: `2px solid ${theme.colorPalette.beige_50}`
    }
  },
  subSectionTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginLeft: 24,
    marginBottom: -8
  },
  subSectionTitle: {
    marginLeft: 0
  },
  changeRow: {
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3, 0),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`,
    margin: '0px 16px',
    backgroundColor: theme.colorPalette.white,
    '&:first-child': {
      borderTop: 'none'
    }
  },
  changeLabel: {
    color: theme.colorPalette.green_90,
    fontSize: 14
  },
  changeValues: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  },
  oldValue: {
    color: theme.colorPalette.beige_75,
    fontSize: 14
  },
  newValue: {
    color: theme.colorPalette.green_90,
    fontSize: 14
  },
  changeArrow: {
    width: 14,
    height: 9.5,
    opacity: 0.6
  },

  // Ineligible chip (used in pricing and change rows)
  ineligibleChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    color: theme.colorPalette.white,
    fontSize: 16,
    fontWeight: 400
  },

  // Footer
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 32
  },
  footerButton: {
    padding: 16,
    marginTop: -6
  },

  rejection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  inside: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    maxWidth: 880,
    margin: theme.spacing(2, 0, 0, 0)
  },
  topRow: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    width: '100%'
  },
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  titleColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  code: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.orange_75
  },
  errorTitle: {
    color: theme.colorPalette.beige_25,
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 600
  },
  claimSubtitle: {
    fontSize: 12,
    color: theme.colorPalette.green_75
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '12px',
    color: theme.colorPalette.white
  },
  subBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: 4,
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  errorIcon: {
    marginRight: theme.spacing(1),
    width: 16,
    height: 16
  },
  boxContent: {
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 400,
    color: theme.colorPalette.white
  }
});

export default makeStyles(styles);
